const carouselItems = [
  {
    title: '韩漫巅峰 · 《她的私密生活》',
    desc: '办公室恋情与职场博弈的完美融合，细腻画风描绘成年人情感的微妙与张力，连续三个月霸占韩漫热榜榜首。',
    tag: '韩漫TOP1',
    img: 'https://readdy.ai/api/search-image?query=A%20dramatic%20romantic%20Korean%20webtoon%20style%20illustration%20with%20warm%20rose%20and%20cream%20tones%2C%20elegant%20office%20setting%20with%20two%20characters%20in%20tense%20emotional%20moment%2C%20soft%20warm%20lighting%2C%20modern%20aesthetic%2C%20clean%20composition%2C%20cinematic%20quality&width=960&height=540&seq=carousel-manga-01&orientation=landscape',
  },
  {
    title: '日漫传奇 · 《咒术回战》最终章',
    desc: '少年Jump王牌作品迎来史诗终章，宿傩与五条悟的宿命对决引爆全球讨论，漫画史上的里程碑之作。',
    tag: '日漫焦点',
    img: 'https://readdy.ai/api/search-image?query=A%20dynamic%20Japanese%20manga%20style%20illustration%20with%20warm%20orange%20and%20dark%20tones%2C%20epic%20battle%20scene%20with%20energy%20explosions%2C%20powerful%20character%20silhouettes%2C%20dramatic%20composition%2C%20clean%20warm%20background%2C%20cinematic%20quality&width=960&height=540&seq=carousel-manga-02&orientation=landscape',
  },
  {
    title: '国漫之光 · 《一人之下》新季',
    desc: '冯宝宝与张楚岚的异人世界继续展开，道家文化与现代都市的完美碰撞，国漫崛起的标杆作品。',
    tag: '国漫推荐',
    img: 'https://readdy.ai/api/search-image?query=A%20beautiful%20Chinese%20manhua%20illustration%20with%20warm%20jade%20and%20gold%20tones%2C%20martial%20arts%20fighters%20in%20ancient%20Chinese%20style%2C%20mystical%20energy%20flowing%2C%20traditional%20aesthetic%2C%20clean%20composition%2C%20cinematic%20quality&width=960&height=540&seq=carousel-manga-03&orientation=landscape',
  },
  {
    title: '悬疑神作 · 《猪圈》全本完结',
    desc: '连环反转+社会派推理的极致演绎，每一个伏笔都在最后一话完美回收，读者评价「今年最震撼的阅读体验」。',
    tag: '编辑力荐',
    img: 'https://readdy.ai/api/search-image?query=A%20mysterious%20thriller%20manga%20illustration%20with%20warm%20sepia%20and%20deep%20shadows%2C%20dark%20alley%20with%20suspenseful%20atmosphere%2C%20subtle%20clues%20hidden%20in%20the%20scene%2C%20noir%20aesthetic%2C%20warm%20background%20tones%2C%20cinematic%20quality&width=960&height=540&seq=carousel-manga-04&orientation=landscape',
  },
  {
    title: '搞笑治愈 · 《社内恋爱》甜蜜连载',
    desc: '办公室搞笑恋爱漫画，萌系画风搭配爆笑日常，工作压力大时的最佳解压良药，读者好评如潮。',
    tag: '人气新作',
    img: 'https://readdy.ai/api/search-image?query=A%20cute%20romantic%20comedy%20manga%20illustration%20with%20warm%20yellow%20and%20peach%20tones%2C%20office%20setting%20with%20chibi%20style%20characters%2C%20funny%20expressions%2C%20bright%20cheerful%20atmosphere%2C%20clean%20composition%2C%20cinematic%20quality&width=960&height=540&seq=carousel-manga-05&orientation=landscape',
  },
  {
    title: '奇幻史诗 · 《剑与魔法》世界观',
    desc: '原创国漫奇幻巨制，构建了完整的中土魔法世界，画风磅礴大气，剧情格局宏大，年度必看系列。',
    tag: '原创精品',
    img: 'https://readdy.ai/api/search-image?query=A%20grand%20fantasy%20manga%20illustration%20with%20warm%20gold%20and%20copper%20tones%2C%20magical%20castle%20floating%20in%20the%20sky%2C%20epic%20adventure%20scene%2C%20swords%20and%20magic%2C%20cinematic%20wide%20composition%2C%20warm%20background%2C%20high%20detail&width=960&height=540&seq=carousel-manga-06&orientation=landscape',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-3">
            焦点专题
          </span>
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">
            不容错过的精彩内容
          </h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {carouselItems.map((item, i) => (
            <div key={i} className="bg-background-50 rounded-xl border border-background-200/70 overflow-hidden cursor-pointer hover:border-primary-200 transition-colors group">
              <div className="relative aspect-[16/9] overflow-hidden bg-background-100">
                <img
                  src={item.img}
                  alt={`樱花漫画焦点专题 - ${item.title}`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <span className="absolute top-3 left-3 px-2.5 py-1 rounded-md bg-primary-500 text-background-50 text-xs font-semibold">{item.tag}</span>
              </div>
              <div className="p-4">
                <h3 className="font-heading text-base text-foreground-900 mb-1.5">{item.title}</h3>
                <p className="text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}